import React, { ErrorInfo } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { IonAlert } from '@ionic/react'
import Logger from '../../services/logger.service'
import { useTranslation } from 'react-i18next'
import { goBack } from '../../utilities/navigation.util'
import { logErrorAction } from '../../features/pcr/store/pcr.actions'
import { useDispatch } from 'react-redux'

const ErrorFallbackAlert: React.FC<{ resetErrorBoundary: () => void }> = ({ resetErrorBoundary }) => {
  const { t } = useTranslation()

  const onOkayClick = () => {
    resetErrorBoundary()
  }

  return (
    <IonAlert
      data-testid='ErrorAlert'
      isOpen={true}
      onDidDismiss={() => onOkayClick}
      header={t('common.Error')}
      message={t('messages.ErrorMessageGeneric')}
      backdropDismiss={false}
      buttons={[{ text: `${t('common.buttons.Ok')}`, handler: onOkayClick }]}
    />
  )
}

const logErrorToService = (error: Error, info: ErrorInfo) => {
  Logger.error(`Logging error: ${error.message}, component stack : ${info.componentStack}`)
}

const ErrorBoundaryWrapper: React.FC = ({ children }) => {
  const dispatch = useDispatch()

  const onReset = () => {
    dispatch(logErrorAction(null))
    goBack()
  }

  return (
    <ErrorBoundary
      onReset={() => onReset()}
      FallbackComponent={ErrorFallbackAlert}
      onError={(error, info) => {
        logErrorToService(error, info)
        dispatch(logErrorAction(error))
      }}>
      {children}
    </ErrorBoundary>
  )
}

export default ErrorBoundaryWrapper
